import { t } from "@lingui/macro";

import { useFlags } from "@/utils/launchDarkly";
import { MarkdownDisplay } from "@whoosh/design-system/src/components/display/MarkdownDisplay/MarkdownDisplay";
import { Box, Text } from "@whoosh/design-system/src/components/primitive";

type EventDetailDescriptionProps = {
  description: string;
};

export const EventDetailDescription = ({
  description,
}: EventDetailDescriptionProps) => {
  const { newPatronEventBookingFlow } = useFlags();
  return (
    <Box width="100%" mt={4}>
      <Text
        variant="mainSmallSemiBold"
        color={newPatronEventBookingFlow ? "text-secondary" : "text-primary"}
      >{t`Description`}</Text>
      <MarkdownDisplay markdown={description} />
    </Box>
  );
};
